import React from "react";
import "./Footer.style.css";

const Footer = () => {
  return (
    <div>
      <div className="py-2 text-center footer-style">
        <strong>
          <i className="fas fa-code"> </i> with{" "}
          <i className="fas fa-heart" style={{ color: "red" }}></i> by Raksha
          Pawar
        </strong>
      </div>
    </div>
  );
};

export default Footer;
